import { render, staticRenderFns } from "./ProductQuickEditMainSupplierBuyNettoPrice.vue?vue&type=template&id=f68f1262&scoped=true"
import script from "./ProductQuickEditMainSupplierBuyNettoPrice.vue?vue&type=script&lang=ts"
export * from "./ProductQuickEditMainSupplierBuyNettoPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68f1262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f68f1262')) {
      api.createRecord('f68f1262', component.options)
    } else {
      api.reload('f68f1262', component.options)
    }
    module.hot.accept("./ProductQuickEditMainSupplierBuyNettoPrice.vue?vue&type=template&id=f68f1262&scoped=true", function () {
      api.rerender('f68f1262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductQuickEditMainSupplierBuyNettoPrice.vue"
export default component.exports